module.exports = __webpack_public_path__ + "static/media/dig-7.df21eb76.png";